import { Component, Input, OnInit } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, App, NavController } from 'ionic-angular';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { SessionProvider } from '../../../../providers/session/session';
import { Product, ProductType } from '../../../../providers/payment.service';
import { User } from '../../../../components/payment/payment';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { QRCodePage } from '../../../me/qrcode/qrcode';

@Component({
  selector: 'page-event-payment',
  templateUrl: 'event-payment.html'
})
export class EventPaymentPage implements OnInit {
  @Input('event') event: EventDetailsModel;
  @Input('event-tabs-instance') parentInstance: any;

  product: Product = null;
  user: User = null;

  constructor(
    private eventService: EventProvider,
    private sessionService: SessionProvider,
    public app: App,
    public appDetector: AppDetectorProvider,
    private toastController: ToastController,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.product = {
      price: this.parentInstance.totalPrice,
      currency: this.translate.defaultLang.includes('de') ? "eur" : "usd",
      type: ProductType.EVENT_TICKET,
      eventId: this.event.id
    };
    console.log(this.product);
    this.user = {
      name: `${this.event.lidOrg}, ${this.sessionService.profile.forName} ${this.sessionService.profile.surName}`,
      email: "klewerenz@me.com"
    };
  }

  showToast(translation, extra = false) {
    let message = extra
      ? this.translate.instant(translation, { amount: this.parentInstance.totalPrice, currency: this.parentInstance.currency })
      : this.translate.instant(translation);

    this.toastController.create({
      message: message,
      duration: 5000,
      position: 'top'
    }).present();
  }

  onCompletePayment(result) {
    if (result) {
      this.sessionService.getToken(false, false).then(token => {

        this.eventService.savePaymentWithToken(this.event.id + "", token).then(() => {
          this.parentInstance.disablePayment();
          this.parentInstance.detailPage = "details";
          if (this.appDetector.isEventsApp() || this.appDetector.isSpooortsApp()) {
            this.eventService.getQRCode(token, this.event.id).then(qrcode => {
              (this.app.getActiveNav() as NavController).push(QRCodePage, { qrcode: qrcode.content });
            });
          }
        })
      }).catch((err) => console.error(err));
    }
  }
}


// WEBPACK FOOTER //
// /src/pages/event/details/event-payment/event-payment.ts